<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10zKsvi/tc-custom/9781555848019.jpg?1702083785922" alt="This image is the cover for the book Bulgari Connection"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bulgari Connection
      </h1>
      <p class="bookDescription body article font2">
        <b>“[A] hilarious page-turner…Weldon’s diabolically clever satire of greed, fashion, sex, and age is smart entertainment of the highest order.”—<i>Booklist </i></b><br/><br/>Grace has just been released from prison, where she was sent for trying to run over her ex-husband’s new wife with her Jaguar in a supermarket parking lot. It may make things a little awkward when all three of them attend a glittering charity ball in London together…<br/><br/>From the Booker Prize-nominated author of <i>The Life and Loves of a She-Devil</i>, this “piquant social comedy” (<i>New York Daily News</i>) is a tale of passion, spite, romance, and revenge, set in the world of the rich, the stylish, the famous—and the infamous. <br/><br/>“Playful, sharp, and funny.”—<i>Los Angeles Times</i><br/><br/>“Swift and amusing.”—<i>The New York Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Fay Weldon
      </h2>
      
      <p class="authorDescription body article">Novelist, playwright, and screenwriter Fay Weldon was born in England, brought up in New Zealand, and returned to the United Kingdom when she was fifteen. She studied economics and psychology at the University of St Andrews in Scotland. She worked briefly for the Foreign Office in London, then as a journalist, and then as an advertising copywriter. She later gave up her career in advertising, and began to write fulltime. Her first novel, <I>The Fat Woman&rsquo;s Joke</I>, was published in 1967. She was chair of the judges for the Booker Prize for fiction in 1983, and received an honorary doctorate from the University of St Andrews in 1990. In 2001, she was named a Commander&#160;of the British Empire.&#160;Weldon&rsquo;s work includes more than twenty novels, five collections of short stories, several children&rsquo;s books, nonfiction books, magazine articles, and a number of plays written for television, radio, and the stage, including the pilot episode for the television series <I>Upstairs Downstairs</I>.&#160;<I>She-Devil</I>, the&#160;film adaption of her 1983 novel&#160;<I>The Life and Loves of a She Devil</I>,<I>&#160;</I>starred Meryl Streep in a Golden Globe&ndash;winning role.&#160;&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8662a37c